import { makeStyles } from "makeStyles";
import { PermissionUserAppRole } from "../models";
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { permissionsTableStyles } from "../styles";
import { useState, useMemo } from "react";
import { TableSortOrder, getComparator, SimpleSortableTableHeadProps, SortableTableHead } from "../SortableTableHead";
import SingleValues from "../SingleValues";

const useStyles = makeStyles()((theme) => ({
  ...permissionsTableStyles(theme)
}));

interface Props {
  permissions?: PermissionUserAppRole[];
}

const UsersPermissions: React.FunctionComponent<Props> = (props) => {
  const { classes } = useStyles();

  const [order, setOrder] = useState<TableSortOrder>("asc");
  const [orderBy, setOrderBy] = useState<keyof PermissionUserAppRole>("identifier");

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof PermissionUserAppRole) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const displayRows = useMemo(
    () => [...(props.permissions ?? [])].sort(getComparator(order, orderBy)),
    [order, orderBy, props.permissions]
  );

  function UsersPermissionsTableHead({ id, label, className }: SimpleSortableTableHeadProps<PermissionUserAppRole>) {
    return (
      <SortableTableHead
        className={className}
        headCell={{
          id,
          label
        }}
        order={order}
        orderBy={orderBy}
        onRequestSort={handleRequestSort}
      />
    );
  }

  return (
    <Box className={classes.childTableContainer}>
      <Table size="small" className={classes.borderedTable}>
        <TableHead>
          <TableRow>
            <TableCell>Via</TableCell>
            <UsersPermissionsTableHead id="identifier" label="Identifier" />
            <UsersPermissionsTableHead id="displayName" label="Display Name" />
            <UsersPermissionsTableHead id="description" label="Description" />
          </TableRow>
        </TableHead>
        <TableBody>
          {displayRows?.map((permission) => (
            <TableRow key={permission.id}>
              <TableCell>{permission.via?.length === 1 ? permission.via[0] : <SingleValues values={permission.via} />}</TableCell>
              <TableCell>{permission.identifier}</TableCell>
              <TableCell>{permission.displayName}</TableCell>
              <TableCell>{permission.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default UsersPermissions;
